import React from "react";
import { Link, useLocation } from "react-router-dom";

const LOGO_URL = "/brand/we-academy-logo.png";

export default function Brand({ minimal = false }) {
  const loc = useLocation();
  return (
    <header
      data-testid="site-header"
      className="w-full bg-white/80 backdrop-blur-md border-b border-[color:var(--border)] sticky top-0 z-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-3"
        >
          <img
            src={LOGO_URL}
            alt="We Academy of Arts and Tech"
            className="h-12 w-auto object-contain"
            data-testid="brand-logo"
          />
        </Link>
        {!minimal && (
          <nav className="flex items-center gap-6">
            <span
              className="font-display font-bold hidden md:inline text-gradient"
              data-testid="brand-tagline"
            >
              We — GIVE THE BOOST
            </span>
            {loc.pathname !== "/admin" && (
              <Link
                to="/admin"
                data-testid="nav-admin-link"
                className="label-mono hover:text-[color:var(--teal-dark)]"
              >
                Admin
              </Link>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}
